import { useQuery } from 'react-query'
import React from "react";
import { fetchSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function ByRepWithRegion({ date }) {
    const fetchData = async () => {
        const { data } = await fetchSignUpsExplorer('byRepWithRegion', date);
        if (data.result && data.result.data) return data.result;
        return { ...data.result, data: [] }; // Ensure data is always an array
    };

    const { data, error, isError, isLoading } = useQuery(
        ['signUpsByRepWithRegion', date],
        fetchData,
        {
            refetchOnWindowFocus: false,
        }
    );
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer  key={"ByRepWithRegion" + date} {...dataProps } />
}
export default ByRepWithRegion